import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2352046e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "agreement-content"
};
const _hoisted_2 = {
  key: 0,
  class: "agreement-details"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://sdi.3g.qq.com/v/2021101914500211231q",
  style: {
    "width": "100%",
    "height": "100%"
  },
  frameborder: "0"
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  key: 1,
  class: "agreement-details"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://sdi.3g.qq.com/v/2022122111264711955",
  style: {
    "width": "100%",
    "height": "100%"
  },
  frameborder: "0"
}, null, -1));
const _hoisted_7 = [_hoisted_6];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_menu_item = _resolveComponent("t-menu-item");
  const _component_t_menu = _resolveComponent("t-menu");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_t_menu, {
    modelValue: _ctx.itemvalue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.itemvalue = $event),
    theme: "light",
    width: "350px"
  }, {
    default: _withCtx(() => [_createVNode(_component_t_menu_item, {
      value: "item1"
    }, {
      default: _withCtx(() => [_createTextVNode("腾讯电脑管家隐私协议")]),
      _: 1
    }), _createVNode(_component_t_menu_item, {
      value: "item2"
    }, {
      default: _withCtx(() => [_createTextVNode(" 腾讯电脑管家软件开放平台开发者协议 ")]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"]), _ctx.itemvalue == 'item1' ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)) : _ctx.itemvalue == 'item2' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)) : _createCommentVNode("", true)]);
}